module.exports = __webpack_public_path__ + "img/icon_sgyl.6a618393.png";